import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs';

import { AppConfigurationService } from '@app-config/services/app-configuration.service';
import { NativeService } from '../../hybrid/native.service';
import { ApplicationUpdateService } from '@notifications/services/application-update.service';
import { RpcIconComponent } from '../../utils/rpc-icon/rpc-icon.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'additional-footer',
    templateUrl: './additional-footer.component.html',
    styleUrls: ['./additional-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RpcIconComponent, AsyncPipe, TranslateModule]
})
export class AdditionalFooterComponent {
    public readonly companyConfiguration$ = this.configurationService.configuration$.pipe(map(configuration => configuration.company));
    public readonly companyLogo$ = this.configurationService.getCompanyLogo();
    public readonly internalCompanyConfigurationLoaded$ = this.configurationService.getInternalCompanyConfigurationLoaded();

    private clicks = 0;

    constructor(
        private readonly configurationService: AppConfigurationService,
        private readonly applicationUpdateService: ApplicationUpdateService,
        private readonly nativeService: NativeService
    ) { }

    public showVersion(): void {
        if (!this.nativeService.isHybridApp().value) {
            return;
        }

        this.clicks++;
        if (this.clicks < 3) {
            return;
        }
        this.clicks = 0;

        const webUIVersion = this.applicationUpdateService.getVersion();
        const publishDate = this.applicationUpdateService.getBuildDate();
        this.nativeService.showVersion(webUIVersion, publishDate);
    }
}
